<template>
	<el-time-picker
		:id="id == null ? prop : id"
		v-model="localModelValue"
		:dir="dir"
		@change="(value) => emitEvent('change', value)"
		format="HH:mm"
		value-format="HH:mm"
		:label="ariaLabel"
		:disabled="disabled"
		:readonly="readonly"
		:placeholder="placeholder"
		:size="size"
		:autofocus="autofocus"
		class="w-100"
		popper-class="modal-popper"
		:teleported="true"
	/>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import * as generalMethods from "@/core/mixins/general_methods";
import * as customValidation from "@/core/mixins/custom_validation";

export default defineComponent({
	name: "umt-element-plus-input-core",
	props: {
		id: { type: String, default: null },
		label: { type: String, default: null },
		prop: { type: String, default: null },
		modelValue: {},
		dir: { type: String, default: null },
		ariaLabel: { type: String, default: null },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		placeholder: { type: String, default: null },
		size: { type: String, default: "default" },
		autofocus: { type: Boolean, default: false },
	},
	setup(props, { emit }) {
		const localModelValue = computed({
			get() {
				return props.modelValue;
			},
			set(newValue) {
				emit("update:modelValue", newValue);
			},
		});

		const emitEvent = (event, value) => {
			emit(event, value);
		};

		return {
			generalMethods,
			customValidation,

			localModelValue,

			emitEvent,
		};
	},
});
</script>
